import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import {
  Row,
  Col,
  Select,
  DatePicker,
  Checkbox,
  Empty,
  Spin,
  Button,
  Radio,
} from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import moment from 'moment';
import Modal from '../../../components/Modal/index';
import { Scrollbars } from 'react-custom-scrollbars';
import { ReactComponent as Arrow } from '../../../images/arrow-right.svg';
import { ReactComponent as CalendarIcon } from '../../../images/calendar.svg';
import { ReactComponent as ArrowDown } from '../../../images/arrow_down.svg';
import { useUnmount } from '@umijs/hooks';
const { Option } = Select;

const Wrapper = styled.div`
  &&& {
    padding: 14px 20px 14px 20px;
    .ant-select-selector {
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      border-radius: 6px;
      .ant-select-selection-search {
        display: flex;
        align-items: center;
      }
    }
    .ant-checkbox-inner {
      border-radius: 4px;
    }
    .ant-radio-group.ant-radio-group-outline {
      width: 98%;
      padding-left: 1px;
    }
    .ant-radio-button-wrapper {
      border: 1px solid #e2e3e3;
      border-radius: 6px;
      &:before {
        display: none;
      }
    }
    .ant-radio-button-wrapper-checked {
      border-color: #4b97e9;
    }
    .ant-picker-input {
      input {
        font-style: italic;
      }
    }
  }
`;

function AddTransaction({
  visible,
  setVisible,
  users,
  storages,
  getBoxes,
  boxes,
  loadingBox,
  postTransaction,
}) {
  const [id, setId] = useState(null);
  const [tab, setTab] = useState(null);
  const [storage, setStorage] = useState(null);
  const [boxId, setBoxId] = useState(null);
  const [date, setDate] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [check, setCheck] = useState(null);
  const { t } = useTranslation();
  const handleChange = (value) => {
    setId(value);
  };

  useEffect(() => {
    if (id) {
      getBoxes({
        transaction__client_id: id,
      });
    }
  }, [id]);

  const handleChangeStorage = (id) => {
    getBoxes({
      warehouse_id: id,
    });
    setStorage(id);
  };
  const onChangeCheck = (e) => {
    setCheck(e.target.checked);
    if (e.target.checked) {
      setTab('user');
      getBoxes({
        transaction__client_id: id,
      });
      setStorage(false);
    } else {
      setTab(null);
    }
  };
  const createTransaction = () => {
    if (id && boxId && date) {
      postTransaction({
        paid_till: date,
        box_id: boxId,
        client_id: id,
      });
      setVisible(!visible);
      setId(null);
      setStorage(false);
      setBoxId(false);
      setDate(false);
    }
  };
  const onChangeDate = (date, dateString) => {
    setDate(new Date(dateString));
    setDateValue(dateString);
  };
  const onChangeBox = (e) => {
    setBoxId(e.target.value);
  };

  const afterClose = () => {
    setId(null);
    setBoxId(null);
    setDate(null);
    setTab(null);
    setStorage(null);
    setDateValue(null);
    setCheck(null);
  };

  return (
    <Modal
      afterClose={afterClose}
      width={561}
      visible={visible}
      setVisible={setVisible}
    >
      <Wrapper>
        <div className="text-17 font-semibold text-black h-41 flex items-center">
          {t('newTransactions')}
        </div>
        <div className="text-12 text-graytext mt-8 mb-13 flex items-center">
          {t('customer')}
        </div>
        <Row className="mb-17" align="middle" type="flex">
          <Col span={12}>
            <Select
              onChange={handleChange}
              showSearch
              className="w-full"
              suffixIcon={null}
              value={id}
              filterOption={(input, option) => {
                return (
                  option.children
                    .join(' ')
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
            >
              {users && users.length !== 0
                ? map(users, (item) => {
                    return (
                      <Option key={item.id} value={item.id}>
                        {item.first_name} {item.last_name}
                      </Option>
                    );
                  })
                : null}
            </Select>
          </Col>
          <Col className="mr-15 ml-15" span={1}>
            <Arrow className="ml-4 mr-4" />
          </Col>
          <Col span={9}>
            <DatePicker
              value={dateValue ? moment(dateValue) : null}
              onChange={onChangeDate}
              placeholder={t('expirationDate')}
              className="rounded-xs h-50 w-full ml-4 italic"
              suffixIcon={<CalendarIcon />}
            />
          </Col>
        </Row>
        <div className="flex items-center">
          <Checkbox
            checked={check}
            onChange={onChangeCheck}
            disabled={id ? false : true}
            className="mr-9 rounded-small"
          />
          {t('showHasBox')}
        </div>
        {!tab ? (
          <>
            <div className="text-12 text-graytext mt-22 mb-13 flex items-center">
              {t('storage')}
            </div>
            <Select
              onChange={handleChangeStorage}
              className="w-full mb-10"
              suffixIcon={<ArrowDown />}
              value={storage}
              // optionFilterProp="children"
            >
              {storages && storages.length !== 0
                ? map(storages, (item) => {
                    return (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    );
                  })
                : null}
            </Select>
          </>
        ) : null}
        {!tab && storage ? (
          <>
            <div className="text-12 text-graytext mt-22 mb-13 flex items-center">
              {t('cells')}
            </div>
            <Spin spinning={loadingBox}>
              <div className="pt-10">
                <Scrollbars style={{ height: 200 }}>
                  <Radio.Group>
                    {boxes && boxes.length !== 0 ? (
                      map(boxes, (box) => {
                        return (
                          <Radio.Button
                            onChange={onChangeBox}
                            value={box.id}
                            defaultChecked={false}
                            className="block mb-10"
                          >
                            {box.name}
                          </Radio.Button>
                        );
                      })
                    ) : (
                      <Empty className="mt-30 mb-30" />
                    )}
                  </Radio.Group>
                </Scrollbars>
              </div>
            </Spin>
          </>
        ) : tab ? (
          <>
            <Spin spinning={loadingBox}>
              <div className="text-12 text-graytext mt-22 mb-13 flex items-center">
                {t('cells')}
              </div>
              <div className="pt-10">
                <Scrollbars style={{ height: 200 }}>
                  <Radio.Group>
                    {boxes && boxes.length !== 0 ? (
                      map(boxes, (box) => {
                        return (
                          <Radio.Button
                            onChange={onChangeBox}
                            value={box.id}
                            defaultChecked={false}
                            className="block mb-10"
                          >
                            <div className="flex justify-between">
                              <div>
                                {box.section.name}, {box.name}
                              </div>
                              <div
                                className={
                                  box.transaction
                                    ? box.transaction.expired
                                      ? 'text-red'
                                      : null
                                    : null
                                }
                              >
                                {t('before')}{' '}
                                {box.transaction
                                  ? moment(box.transaction.paid_till).format(
                                      'DD.MM.YYYY',
                                    )
                                  : null}
                              </div>
                            </div>
                          </Radio.Button>
                        );
                      })
                    ) : (
                      <Empty className="mt-30 mb-30" />
                    )}
                  </Radio.Group>
                </Scrollbars>
              </div>
            </Spin>
          </>
        ) : (
          <Empty className="mt-30 mb-30" />
        )}
        <div className="flex justify-center items-center">
          <Button
            onClick={() => {
              createTransaction();
            }}
            className="text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('create')}</span>
          </Button>
        </div>
      </Wrapper>
    </Modal>
  );
}

AddTransaction.propTypes = {};

export default AddTransaction;
